module.exports = __webpack_public_path__ + "media/promo/velle/images/oleg-3b262d42059747730dcfcb40edc2b8c9.png";